'use client'

import cx from 'classnames'
import React, { useEffect, useRef } from 'react'
import { useInView } from 'react-intersection-observer'

import '@/components/Common/LazyVideo/LazyVideo.scss'

export default function LazyVideo({
  width,
  height,
  src,
  type,
  animationRef = null,
  style = {},
  className = '',
}: {
  width: number
  height: number
  src: string
  type: string
  className?: string
  style?: React.CSSProperties | {}
  animationRef?: React.Ref<HTMLDivElement> | null
}) {
  const { ref, inView } = useInView({
    threshold: 0,
  })

  const videoRef = useRef<HTMLVideoElement>(null)
  const video = videoRef.current

  useEffect(() => {
    if (video != null && video.paused && inView == true) {
      video.play().catch(() => {})
    }
  }, [inView, video])

  return (
    <div
      ref={ref}
      className={'c-lazyVideo'}
      style={{
        paddingBottom: `${(height / width) * 100}%`,
      }}
    >
      <div
        {...(animationRef != null ? { ref: animationRef } : {})}
        className={cx('c-lazyVideo__video', className)}
        style={style}
      >
        <video ref={videoRef} loop muted playsInline>
          <source src={src} type={type} />
        </video>
      </div>
    </div>
  )
}
